<p>collection-component works!</p>
